import React from 'react';
import { Typography, Row, Col } from 'antd';

const { Title, Paragraph } = Typography;

/**
 * CarouselEvents
 *
 * Slide que explica el módulo de Eventos.
 */
const CarouselEvents = () => (
    <Row justify="center" align="middle" style={{ minHeight: '60vh', padding: 24 }}>
        <Col span={24} style={{ textAlign: 'center' }}>
            <Title level={2} style={{ marginBottom: 16 }}>Eventos</Title>
            <Paragraph>
                Aquí podrás crear, editar y monitorizar los eventos de tu organización en tiempo real.
                Usa los filtros avanzados y la búsqueda para encontrar rápidamente eventos relevantes.
            </Paragraph>
            <Paragraph>
                <strong>Consejo:</strong> Haz clic en un evento para ver sus detalles completos y acciones asociadas.
            </Paragraph>
        </Col>
    </Row>
);

export default CarouselEvents;